export default __webpack_public_path__ + "static/media/06_DAIF_Security_01.6ef84388.mp4";